import React, { useState, useEffect } from "react";
import AdminDashboard from "../../AdminDashboard"
import { isAuthenticated } from "../../../../auth"
import { Redirect } from "react-router-dom";
import { updateSubcategory } from "../../apiAdmin"
import { getSubcategory, listCategories } from "../../../apiCore"
import * as qs from 'query-string';
import { dict } from "../../../../dictionary";
import { default_url } from "../../../..";

function UpdateSubcategory() {

    const [values, setValues] = useState({
        _id: "",
        enName: "",
        arName: "",
        category: "",
        image: "",
        hidden: "",
        error: "",
        redirectToReferrer: false,
    });
    const [categories, setCategories] = useState([]);

    const parsed = qs.parse(window.location.search);

    useEffect(() => {
        async function fetchData() {
            const subcategory = await getSubcategory(parsed.subcategory_id)
                .then(res => {
                    if (res.error) {
                        setValues({ ...values, error: res.error, redirectToReferrer: true });
                    } else {
                        setValues({ _id: res._id, enName: res.enName, arName: res.arName, category: res.category, hidden: res.hidden ? "yes" : "no", image: res.image });
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        }
        fetchData();
    }, []);

    useEffect(() => {
        async function fetchData() {
            const cats = await listCategories()
                .then(res => {
                    setCategories(res);
                })
                .catch(err => {
                    console.log(err);
                });
        }
        fetchData();
    }, []);

    const { user, token } = isAuthenticated();
    const { _id, enName, arName, category, image, hidden, error, redirectToReferrer } = values;


    const handleChange = name => event => {
        setValues({ ...values, error: false, [name]: event.target.value });
    };

    const clickSubmit = (event) => {
        event.preventDefault();
        updateSubcategory({ _id, enName, arName, category, image, hidden }, user._id, token)
            .then(data => {
                if (data.error) {
                    console.log(data.error);

                    setValues({ ...values, error: data.error, redirectToReferrer: false });
                } else {
                    setValues({
                        ...values,
                        error: undefined,
                        redirectToReferrer: true
                    });
                }
            })
    }

    const CategoriesSelector = () => {
        return (
            <select onChange={handleChange("category")} className="inputField form-control" value={category}>
                <option value={null}></option>
                {
                    categories.sort((a, b) => a.position - b.position).map((category, index) => {
                        return (
                            <option key={index} value={category._id}>{category.enName + " | " + category.arName}</option>
                        )
                    })

                }
            </select>
        )
    }

    const hiddenSelector = () => {
        return (
            <select onChange={handleChange("hidden")} name="hidden" className="inputField form-control" value={hidden}>
                <option value=""></option>
                <option value="no">{dict["no_._it_isn't_hidden"]}</option>
                <option value="yes">{dict["yes_._it_is_hidden"]}</option>
            </select>
        )
    }

    const showError = () => {
        return (
            <div className="alert alert-danger" style={{ display: error ? "" : "none" }}>
                {error}
            </div>
        )
    }

    const redirectUser = () => {
        if (redirectToReferrer) {
            return (
                <Redirect to={{ pathname: default_url + 'admin/subcategories', state: { prevPath: "edit", error } }} />
            )
        }
    }

    const arStyleRequiredStart = {
        left: "30px"
    }
    const enStyleRequiredStart = {
        right: "30px"
    }
    const arStylelabel = {
        float: "right"
    }
    const enStylelabel = {
        float: "left"
    }

    const form = () => {
        return (
            <div className="userProfileDataContainer">
                {showError()}
                {redirectUser()}
                <h3 className="formContainerTitle">{dict["edit_subcategory"]}</h3>
                <h6 className="requiredStar requiredStarUserDashbord" style={default_url == "/en/" ? enStyleRequiredStart : arStyleRequiredStart}>{dict["required"]}</h6>
                <form >
                    <label className="inputLabel" style={default_url == "/en/" ? enStylelabel : arStylelabel}>{"ID"}</label>
                    <input type="text" value={_id} className="inputField form-control" disabled></input>
                    <label className="inputLabel" style={default_url == "/en/" ? enStylelabel : arStylelabel}>{dict["subcategory_english_name"]} <span className="redStar">*</span></label>
                    <input onChange={handleChange("enName")} type="text" value={enName} className="inputField form-control" id="enName" placeholder={dict["subcategory_english_name"]}></input>
                    <label className="inputLabel" style={default_url == "/en/" ? enStylelabel : arStylelabel}>{dict["subcategory_arabic_name"]}</label>
                    <input onChange={handleChange("arName")} type="text" value={arName} className="inputField form-control" id="arName" placeholder={dict["subcategory_arabic_name"]}></input>
                    <label className="inputLabel" style={default_url == "/en/" ? enStylelabel : arStylelabel}>{dict["category"]} <span className="redStar">*</span></label><br />
                    {CategoriesSelector()}
                    <label className="inputLabel" style={default_url == "/en/" ? enStylelabel : arStylelabel}>{dict["hidden"]} <span className="redStar">*</span></label><br />
                    {hiddenSelector()}
                    <label className="inputLabel" style={default_url == "/en/" ? enStylelabel : arStylelabel}>{dict["subcategory_image"]} <span className="redStar">*</span></label>
                    <input onChange={handleChange("image")} type="text" value={image} className="inputField form-control" id="image" placeholder={dict["subcategory_image"]}></input>
                    <button onClick={clickSubmit} type="submit" className="dashboardBtn">{dict["save"]}</button>
                </form>
            </div>
        )
    }

    return (
        <AdminDashboard
            active="3"
            data={form}
        />
    )
}

export default UpdateSubcategory;